import React, { useState, useEffect } from "react";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import localization from "assets/localization/localization";
import Regex from "services/utils/regex/Regex";
import Images from "assets/images/imageData";

import { Button } from "react-bootstrap";

const Filters = ({
  showFilter = false,
  filterToggle,
  applyFilter
}) => {
  const filterInputs = {
    site_number:'',
    mrf_number:'',
    created_by:''
  };

  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
  const [listStatus, setListStatus] = useState("");
  //console.log('filter data ' + JSON.stringify(filterFieldsData));
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
        filterFieldsData && localStorage.setItem("applyFilter", JSON.stringify(filterFieldsData));
        listStatus && localStorage.setItem("statusFilter", JSON.stringify(listStatus));
      }}
    >
    <div className={showFilter ? "show-filter" : ""}>
      {showFilter && (
        <div className="filter-wrapper">
          <div className="filter-heading">
            <h4>MRF Filters</h4>
            <Button onClick={filterToggle} className="close">
              <i className="close"></i>
            </Button>
          </div>
          <div className="filter-body scrollbar-styling">
            <ConstantInput
              label={localization.siteNumber}
              value={filterFieldsData && filterFieldsData.site_number}
              regex={Regex.number.test(
                filterFieldsData && filterFieldsData?.site_number
              )}
              handleChange={(val) => {
                setFilterFieldsData({ ...filterFieldsData, site_number: val });
              }}
            />
            <ConstantInput
              label={localization.mrfNumber}
              value={filterFieldsData && filterFieldsData.mrf_number}
              regex={Regex.number.test(
                filterFieldsData && filterFieldsData?.mrf_number
              )}
              handleChange={(val) => {
                setFilterFieldsData({ ...filterFieldsData, mrf_number: val });
              }}
            />
            <ConstantInput
              label={localization.createdBy}
              value={filterFieldsData && filterFieldsData.created_by}
              regex={Regex.number.test(
                filterFieldsData && filterFieldsData?.created_by
              )}
              handleChange={(val) => {
                setFilterFieldsData({ ...filterFieldsData, created_by: val });
              }}
            />

            <div className="btn-wrapper">
              <button
                disabled={false}
                type="submit"
                className="btn btn-primary"
              >
                {localization.applyFilter}
                <img src={Images?.ArrowRight} alt="" />
              </button>
              <br />
              <br />
              <button
                onClick={() => {
                  localStorage.setItem(
                    "applyFilter",
                    JSON.stringify(filterInputs)
                  );
                  applyFilter(filterInputs);
                  localStorage.setItem("statusFilter", JSON.stringify({}));
                }}
                type="button"
                className="btn btn-primary"
              >
                {localization.removeFilter}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    </form>
  );
};

export default Filters;
